
import DragUpload from '@/components/util/DragUpload.vue';
import List from '@/components/util/List.vue';
import StatusStepper from '@/components/orders/StatusStepperComponent.vue';
import OrderPartListComponent from '@/components/orders/OrderPartListComponent.vue';
import OrderLaborListComponent from '@/components/orders/OrderLaborListComponent.vue';
import OrderAssetListComponent from '@/components/orders/OrderAssetListComponent.vue';

import TransferOrderComponent from '@/components/orders/TransferOrderComponent.vue';

import ReassignOrderComponent from '@/components/orders/ReassignOrderComponent.vue';
import CompleteOrderComponent from '@/components/orders/CompleteOrderComponent.vue';
import DncOrderComponent from '@/components/orders/DncOrderComponent.vue';
import OpenSubStatusComponent from '@/components/orders/OpenSubStatusComponent.vue';
import CompleteSubStatusComponent from '@/components/orders/CompleteSubStatusComponent.vue';

import ApproveDenyComponent from '@/components/orders/ApproveDenyComponent.vue';

import { ColumnDisplayOption } from '@/models/ColumnDisplayOption';

import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import {
  PerformoSettings,
  Property,
  ReportsApi,
  ValidationProblemDetails,
  Workorder,
  WorkordersApi
} from 'performo-api';

import DetailLayout from '@/components/system/DetailsLayout.vue';
import BuildingDisplayComponent from '@/components/system/BuildingDisplayComponent.vue';
import DocumentList from '@/components/documents/DocumentListView.vue';

import JobPriorityEditor from '@/components/orders/editors/JobPriorityEditor.vue';
import JobTypeEditor from '@/components/orders/editors/JobTypeEditor.vue';
import RequestTypeEditor from '@/components/orders/editors/RequestTypeEditor.vue';

import TargetDateEditor from '@/components/orders/editors/TargetDateEditor.vue';
import StartDateEditor from '@/components/orders/editors/StartDateEditor.vue';
import DescriptionEditor from '@/components/orders/editors/DescriptionEditor.vue';

import BuildingEditor from '@/components/orders/editors/BuildingEditor.vue';
import SuiteEditor from '@/components/orders/editors/SuiteEditor.vue';
import FloorEditor from '@/components/orders/editors/FloorEditor.vue';
import Location3Editor from '@/components/orders/editors/Location3Editor.vue';

import StartStopTimer from '@/components/orders/StartStopTimer.vue';

import ProcedureItemsComponent from '@/components/orders/ProcedureItemsComponent.vue';

import { Location } from '../../../models/location.model';

@Component({
  components: {
    List,
    StatusStepper,
    DragUpload,
    ProcedureItemsComponent,
    OrderLaborListComponent,
    OrderPartListComponent,
    ReassignOrderComponent,
    TransferOrderComponent,
    CompleteOrderComponent,
    DncOrderComponent,
    OpenSubStatusComponent,
    CompleteSubStatusComponent,
    OrderAssetListComponent,
    DetailLayout,
    BuildingDisplayComponent,

    DocumentList,

    JobPriorityEditor,
    JobTypeEditor,
    RequestTypeEditor,
    TargetDateEditor,
    StartDateEditor,
    DescriptionEditor,
    BuildingEditor,
    SuiteEditor,
    FloorEditor,
    Location3Editor,
    StartStopTimer,
    ApproveDenyComponent
  },
  computed: mapGetters({
    settings: 'settings',
    reportsApi: 'reportsApi',
    currentProperty: 'currentProperty',
    currentPropertyId: 'currentPropertyId',
    ordersApi: 'ordersApi'
  })
})
export default class WorkerDetail extends Vue {
  private reportsApi!: ReportsApi;
  private currentProperty!: Property;
  private currentPropertyId!: string;
  private ordersApi!: WorkordersApi;

  private settings!: PerformoSettings;

  private survey = { message: '', rating: 0 };
  private commentText = '';
  private commentPrivateText = '';
  private printLoading = false;
  private showSpeedDial = false;
  private openLoading = false;
  private holdLoading = false;
  private dncLoading = false;

  get locations(): Location[] {
    return [
      {
        id: this.order.workorderId,
        title: 'Order #' + this.order.orderNumber,
        position: { lat: this.order.latitude, lng: this.order.longitude },
        description: ''
      }
    ];
  }

  get photoSource() {
    if (!this.photo) return null;
    if (this.photo.size <= 0) return null;
    return window.URL.createObjectURL(this.photo);
  }

  get orderNotesDisplay() {
    if (!this.order.notes) return '';
    return this.order.notes.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
  get orderPrivateNotesDisplay() {
    if (!this.order.privateNotes) return '';
    return this.order.privateNotes.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
  get showSubmitSurvey() {
    return this.survey.rating !== 0;
  }

  get holdCommandText() {
    return this.order.orderStatus === 'Open' ? 'Hold' : 'Un-hold';
  }

  get order() {
    return this.orderProp;
  }

  get logDisplayOptions(): ColumnDisplayOption[] {
    return [
      {
        displayName: 'Date',
        columnName: 'logDateTime',
        dateFormatKind: 3,
        dontSort: true
      },
      { displayName: 'User', columnName: 'logUser', dontSort: true },
      { displayName: 'Activity', columnName: 'logActivity', dontSort: true }
    ];
  }

  get taskDisplayOptions(): ColumnDisplayOption[] {
    return [
      { displayName: 'Sequence', columnName: 'sortOrder', dontSort: true },
      { displayName: 'Task', columnName: 'taskTextCalc', dontSort: true },
      { displayName: 'Meter Name', columnName: 'meterName', dontSort: true },
      { displayName: 'Data Entry', columnName: 'dataEntry', dontSort: true },
      { displayName: 'Meter Units', columnName: 'meterUnits', dontSort: true }
    ];
  }

  private get orderStatusIsCompleteSubStatus() {
    if (this.order.orderStatus && this.settings.completeSubStatuses) {
      return this.settings.completeSubStatuses.includes(this.order.orderStatus);
    } else return false;
  }

  private get orderStatusIsOpenSubStatus() {
    if (this.order.orderStatus && this.settings.openSubStatuses) {
      return this.settings.openSubStatuses.includes(this.order.orderStatus);
    } else return false;
  }

  private addPrivateCommentIfEnter(sender: KeyboardEvent) {
    if (sender.keyCode === 13) {
      // clear
      this.addPrivateComment();
    }
  }

  private addPrivateComment() {
    this.$emit('commentAdded', this.commentPrivateText, 'private');
    this.commentPrivateText = '';
  }

  private addPublicCommentIfEnter(sender: KeyboardEvent) {
    if (sender.keyCode === 13) {
      // clear
      this.addPublicComment();
    }
  }

  private addPublicComment() {
    this.$emit('commentAdded', this.commentText, 'public');
    this.commentText = '';
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private successHandler(data: Workorder) {
    if (this.refresh) {
      this.refresh();
    }
  }

  private errorHandler(error: string | Error) {
    console.log(error);
  }

  private handleScroll() {
    const scrolledPx = document.documentElement.scrollTop;
    this.showSpeedDial = scrolledPx > 75 ? true : false;
  }

  private async mounted() {
    // blank
  }

  private async created() {
    window.addEventListener('scroll', this.handleScroll);
  }

  private async destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  @Prop({ required: true })
  private orderProp!: Workorder;

  @Prop() private photo!: Blob;

  @Prop({ required: false, type: Function })
  private refresh!: (response?: Workorder) => Promise<void>;

  private async editorError(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    let vpd: ValidationProblemDetails;
    if (error instanceof Response) {
      vpd = await error.json();
    } else {
      vpd = error;
    }

    if (vpd.errors) {
      alert(vpd.errors[''][0]);
    }
    // some data may still have changed
    this.refresh();
  }

  private printBatch() {
    this.printLoading = true;
    this.reportsApi
      .queueReport({
        queueReportCommand: {
          outputType: 'PDF',
          propertyId: this.order.propertyId,
          reportName: `Work Order Report - ${this.order.orderCategory} Order # ${this.order.orderNumber}`,
          reportId: 1000,
          foundSetIds: this.order.workorderId
        }
      })
      .then(() => {
        this.printLoading = false;
        this.$router.push({ name: 'reports', params: {} });
      });
    // 1000 = detail
    // 1002 = list, details
    // 1004 = list, list
  }

  get canEdit() {
    let canDoQEdit = true;
    this.$store.getters.currentUser.profile.candoq.forEach((candoq: string) => {
      if (candoq === 'Edit Orders: Limited') {
        canDoQEdit = false;
      }
    });
    return canDoQEdit;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private successDocUploadHandler(data: Document) {
    this.refresh();
  }

  private errorDocUploadHandler(error: string | Error) {
    console.log(error);
  }

  private async onOpenClickHandler() {
    if (!this.order.workorderId) return;

    this.openLoading = true;
    try {
      await this.ordersApi.openOrder({ workorderId: this.order.workorderId });
      this.refresh();
    } catch (error) {
      this.editorError(error as ValidationProblemDetails);
    }
    this.openLoading = false;
  }

  private async onHoldClickHandler() {
    if (!this.order.workorderId) return;

    this.holdLoading = true;
    try {
      await this.ordersApi.setHold({ workorderId: this.order.workorderId });
      this.refresh();
    } catch (error) {
      this.editorError(error as ValidationProblemDetails);
    }
    this.holdLoading = false;
  }
}
